import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import getters from './getters'
import state from './state'
import mutations from './mutations'

Vue.use(Vuex)
export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations,
  strict: false
})



// WEBPACK FOOTER //
// ./src/store/index.js